import FormChangePassword from './components/FormChangePassword'

/** @module Pages/Usuario/UserSettings */

/**
 * Página de Configuración de cuenta de usuario.
 * @returns {JSX.Element} Retorna el componente UserSettings.
 */
function UserSettings() {
    return (
        <div className='container py-4'>
            <div className='fs-3 mb-5 text-center'>Configuración de Usuario</div>
            <div className='w-100 w-xl-50'>
                <div className='fs-4 mb-3'>Cambiar contraseña</div>
                <FormChangePassword />
            </div>
        </div>
    )
}
export default UserSettings
